module.exports = __webpack_public_path__ + "img/ico_door_2.a9b841a4.png";